const SET_TAGS = "SET_TAGS";
const ADD_TAG = "ADD_TAG";
const EDIT_TAG = "EDIT_TAG";
const REMOVE_TAG = "REMOVE_TAG";

export { SET_TAGS, ADD_TAG, EDIT_TAG, REMOVE_TAG };
